export const fetchWithAuth = async (url: string, options: any = {}) => {
  const token = localStorage.getItem("token") || sessionStorage.getItem("token");
  
  const headers = {
    ...options.headers,
  };

  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  return fetch(url, {
    ...options,
    headers,
  });
};
